module.exports = __webpack_public_path__ + "img/Close_1.c759b8dd.svg";